// extracted by mini-css-extract-plugin
export default {"isActive":"Profile_isActive__P+bR8","link":"Profile_link__vE40s","hidden":"Profile_hidden__QKu0s","menuIcon":"Profile_menuIcon__0Niaj"};